import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-undo-variant-component',
  templateUrl: './icon-undo-variant-component.html',
  styleUrl: './icon-undo-variant-component.scss',
  standalone: false,
})
export class IconUndoVariantComponent {
  @Input() tooltip?: string;
}
